module.exports = new __parcel__URL__("drag-and-drop-fields.ec193bdc.svg").toString();